/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {Languages} from './Languages'
import {toAbsoluteUrl} from '../../../helpers'
import { useQuery } from 'react-query'
import { get_user_profile } from '../../../../app/modules/profile/api/profileApi'
type User = {
  id: number;
  department_id: string;
  department_name: string | undefined;
  title: string | undefined;
  firstname: string | undefined;
  middlename: string | undefined;
  lastname: string | undefined;
  telephone: string | undefined;
  email: string | undefined;
  password: string | undefined;
  profile_picture: string | undefined;
  mobile: string | undefined;
  picture: string | undefined;
  role: string | undefined;
  password_confirmation: string | undefined;
  status: number | undefined;
  created_at: string;
  deleted_at: string;
  updated_at: string;
};
const HeaderUserMenu: FC = () => {
  const {logout} = useAuth()
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  
  const authData = (() => {
    const data = localStorage.getItem('kt-auth-react-v');
    try {
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('Error parsing kt-auth-react-v from localStorage:', error);
      return null;
    }
  })();

  // Fetch user profile from API
  const { data: profileResponse } = useQuery(
    'UserProfileForMenu',
    get_user_profile,
    { 
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!authData?.access_token
    }
  );

  useEffect(() => {
    if (authData?.admin) {
      setCurrentUser(authData.admin);
    }
  }, []);

  const access_token: string = authData?.access_token || null;
  const navigate = useNavigate();
  
  // Helper function to get full profile picture URL
  const getProfilePictureUrl = (pictureUrl: string | null | undefined): string | null => {
    if (!pictureUrl) return null;
    
    // If already a full URL (starts with http:// or https://), return as is
    if (pictureUrl.startsWith('http://') || pictureUrl.startsWith('https://')) {
      return pictureUrl;
    }
    
    // Otherwise, prepend API base URL
    let baseURL = process.env.REACT_APP_API_URL || '';
    if (!baseURL) return pictureUrl;
    
    // Remove /api from the end of baseURL if present
    baseURL = baseURL.replace(/\/api\/?$/, '');
    
    // Remove trailing slash from baseURL and leading slash from pictureUrl
    const cleanBaseURL = baseURL.replace(/\/$/, '');
    const cleanPictureUrl = pictureUrl.replace(/^\//, '');
    
    return `${cleanBaseURL}/${cleanPictureUrl}`;
  };

  // Get user data - prefer API response, fallback to localStorage
  const profileData = profileResponse?.data || null;
  const localStorageAdmin = authData?.admin || null;
  
  // Priority: API response > localStorage admin
  // API now returns 'name' field instead of 'full_name'
  const userName = profileData?.name 
    || profileData?.full_name 
    || localStorageAdmin?.name
    || localStorageAdmin?.full_name 
    || localStorageAdmin?.firstname 
    || 'User';
  const userEmail = profileData?.email || localStorageAdmin?.email || '';
  const rawProfilePicture = profileData?.profile_picture 
    || currentUser?.profile_picture 
    || localStorageAdmin?.profile_picture 
    || null;
  const userProfilePicture = getProfilePictureUrl(rawProfilePicture);
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item m-3'>
        <div className='d-flex align-items-center'>
          <div className='symbol symbol-50px me-3'>
            {userProfilePicture ? (
              <div
                className='symbol symbol-fixed position-relative'
                style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                }}
              >
                <img
                  src={userProfilePicture || ''}
                  alt={userName}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                  onError={(e) => {
                    // Fallback to blank image if URL fails to load
                    const target = e.target as HTMLImageElement;
                    target.src = toAbsoluteUrl('/media/avatars/blank.png');
                  }}
                />
              </div>
            ) : (
              <div
                className='symbol symbol-fixed position-relative'
                style={{
                  width: '50px',
                  height: '50px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                }}
              >
                <img
                  src={toAbsoluteUrl('/media/avatars/blank.png')}
                  alt={userName}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
            )}
          </div>
          <div className='d-flex flex-column'>
            <div className='fw-bold fs-5 text-dark'>
              {userName}
              <span className='badge badge-light-success ms-2'>Online</span>
            </div>
            {userEmail && (
              <span className='text-muted fs-7'>
                {userEmail}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={'/profile'} className='menu-link px-5'>
          My Profile
        </Link>
      </div>
      
      {/* TODO: Uncomment when functional */}
      {/* <div className='menu-item px-5'>
        <Link to={'/change-password'} className='menu-link px-5'>
          Change Password
        </Link>
      </div> */}
    {/* commenting for future use  */}
      {/* <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          <span className='menu-text'>My Projects</span>
          <span className='menu-badge'>
            <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>
          </span>
        </a>
      </div>

      <div
        className='menu-item px-5'
        data-kt-menu-trigger='hover'
        data-kt-menu-placement='left-start'
        data-kt-menu-flip='bottom'
      >
        <a href='#' className='menu-link px-5'>
          <span className='menu-title'>My Subscription</span>
          <span className='menu-arrow'></span>
        </a>

        <div className='menu-sub menu-sub-dropdown w-175px py-4'>
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Referrals
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Billing
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Payments
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link d-flex flex-stack px-5'>
              Statements
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='View your statements'
              ></i>
            </a>
          </div>

          <div className='separator my-2'></div>

          <div className='menu-item px-3'>
            <div className='menu-content px-3'>
              <label className='form-check form-switch form-check-custom form-check-solid'>
                <input
                  className='form-check-input w-30px h-20px'
                  type='checkbox'
                  value='1'
                  defaultChecked={true}
                  name='notifications'
                />
                <span className='form-check-label text-muted fs-7'>Notifications</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          My Statements
        </a>
      </div>

      <div className='separator my-2'></div>

      <Languages />

      <div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-5'>
          Account Settings
        </Link>
      </div> */}

      <div className='menu-item px-5'>
        <a 
          onClick={() => {
            // Get api_token from localStorage before logout
            const api_token = authData?.api_token || authData?.access_token || null;
            logout(api_token);
          }} 
          className='menu-link px-5'
        >
          Sign Out
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
